





















import { Component, Vue } from 'vue-property-decorator'
import { ITuileNav } from '@/models/ui/ITuileNav'


@Component({
  name:"SectionTuileNav",
  components: {    
  },
  props:{
    title:String,
    items:Array
  }
})
export default class SectionTuileNav extends Vue {  
  title!:string
  items!:Array<ITuileNav>  
}
